/**
 * External dependencies
 */
import React from 'react';
import { TowerProvider, Stack, Text, Heading, Box } from '@towersystems/towersystems-design-system';

/**
 * Internal dependencies
 */
import Button from 'components/button';

/**
 * Style dependencies
 */
import './styles.scss';

const ErrorLayout = (props) => {
    const reloadPage = () => {
        window.location.reload();
    };
    return (
        <TowerProvider>
            <Box
                display='flex'
                alignItems='center'
                justifyContent='center'
                flexDirection='column'
                style={{ height: '100%' }}
            >
                <Stack space='medium'>
                    <Heading level='1'>Opps! Something went wrong.</Heading>
                    <Text>If error persists, please contact support.</Text>
                    <Button onClick={reloadPage} primary>
                        Reload
                    </Button>
                </Stack>
            </Box>
        </TowerProvider>
    );
};

export default ErrorLayout;
